module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets Brown Wood tall-94149b32.jpg";